export const MODULE_FUNCTIONALITY_ENUM = {
  PROPRIEDADE: {
    id: 'PROPRIEDADE',
    descricao: 'Módulo Geral - Minhas Fazendas',
  },
  PROD_INSUMO: {
    id: 'PROD_INSUMO',
    descricao: 'Módulo Geral - Cadastro de Produto / Insumo',
  },
  AGRIC_PRAGA_DOENCA: {
    id: 'AGRIC_PRAGA_DOENCA',
    descricao: 'Módulo Geral - Cadastro de Pragas e Doenças'
  },
  AGRIC_CONTROLE_PRAGA_DOENCA: {
    id: 'AGRIC_CONTROLE_PRAGA_DOENCA',
    descricao: 'Módulo Agricultura - Controle de Pragas e Doenças'
  },
  PLUVIOMETRO_DIGITAL: {
    id: 'PLUVIOMETRO_DIGITAL',
    descricao: 'Módulo Geral - Pluviômetro Digital',
  },
  USUARIO: { id: 'USUARIO', descricao: 'Módulo Geral - Cadastro de Usuários' },
  TIPO_EMBALAGEM: {
    id: 'TIPO_EMBALAGEM',
    descricao: 'Módulo Geral - Cadastro de Tipo de Embalagem',
  },
  FUNCIONARIO_CARGO: {
    id: 'FUNCIONARIO_CARGO',
    descricao: 'Módulo Geral - Cadastro de Cargo - Funcionário',
  },
  FUNCIONARIO: {
    id: 'FUNCIONARIO',
    descricao: 'Módulo Geral - Cadastro de Funcionário',
  },
  PATRIMONIO: {
    id: 'PATRIMONIO',
    descricao: 'Módulo Geral - Cadastro de Patrimônio',
  },
  CLIENTE: { id: 'CLIENTE', descricao: 'Módulo Geral - Cadastro de Clientes' },
  FORNECEDOR: {
    id: 'FORNECEDOR',
    descricao: 'Módulo Geral - Cadastro de Fornecedor',
  },
  TRANSPORTADORA: {
    id: 'TRANSPORTADORA',
    descricao: 'Módulo Geral - Cadastro de Transportadora',
  },
  VEICULO: { id: 'VEICULO', descricao: 'Módulo Geral - Cadastro de Veículo' },
  IDENTIFICADOR: {
    id: 'IDENTIFICADOR',
    descricao: 'Módulo Geral - Cadastro de Identificadores',
  },
  MOTORISTA: {
    id: 'MOTORISTA',
    descricao: 'Módulo Geral - Cadastro de Motorista',
  },
  UNIDADE_MEDIDA: {
    id: 'UNIDADE_MEDIDA',
    descricao: 'Módulo Geral - Cadastro Unidade de Medida',
  },
  UNIDADE_MEDIDA_CONVERSAO: {
    id: 'UNIDADE_MEDIDA_CONVERSAO',
    descricao: 'Módulo Geral - Cadastro Unidade de Medida Conversão',
  },
  CONFIG: { id: 'CONFIG', descricao: 'Módulo Geral - Configurações' },
  PARTNER_CERTIFICADO_DIGITAL: {
    id: 'PARTNER_CERTIFICADO_DIGITAL',
    descricao: 'Módulo Parceiro Certificado Digital',
  },
  PARTNER_PATRIMONIO: {
    id: 'PARTNER_PATRIMONIO',
    descricao: 'Módulo Parceiro de Patrimonio',
  },
  SAFRA: {
    id: 'SAFRA',
    descricao: 'Módulo Agricultura - Cadastro de Safra',
  },
  TALHAO: {
    id: 'TALHAO',
    descricao: 'Módulo Agricultura - Cadastro de Talhão',
  },
  PROCEDIMENTO: {
    id: 'PROCEDIMENTO',
    descricao: 'Módulo Agricultura - Cadastro de Procedimento',
  },
  AGRIC_CULTURA: {
    id: 'AGRIC_CULTURA',
    descricao: 'Módulo Agricultura - Cadastro de Cultura',
  },
  AGRIC_PRODUTO_AGRICOLA: {
    id: 'AGRIC_PRODUTO_AGRICOLA',
    descricao: 'Módulo Agricultura - Cadastro Produto Agrícola',
  },
  DESPESA_DIRETA: {
    id: 'DESPESA_DIRETA',
    descricao: 'Módulo Agricultura - Cadastro de Despesa Direta',
  },
  PLANEJAMENTO: {
    id: 'PLANEJAMENTO',
    descricao: 'Módulo Agricultura - Planejamento da Safra',
  },
  ATIV_PLANTIO: {
    id: 'ATIV_PLANTIO',
    descricao: 'Módulo Agricultura - Execução da Safra',
  },
  ATIV_COLHEITA: {
    id: 'ATIV_COLHEITA',
    descricao: 'Módulo Agricultura - Colheita',
  },
  ATIV_AGRIC_ROMANEIO_COLHEITA: {
    id: 'ATIV_AGRIC_ROMANEIO_COLHEITA',
    descricao: 'Módulo Agricultura - Romaneio Colheita',
  },
  AGRIC_APLICACAO_ESTAGIO: {
    id: 'AGRIC_APLICACAO_ESTAGIO',
    descricao: 'Módulo Agricultura - Aplicação Estágio',
  },
  AGRIC_VENDAS_PRODUCAO: {
    id: 'AGRIC_VENDAS_PRODUCAO',
    descricao: 'Módulo Agricultura - Vendas Produção Agrícola',
  },
  AGRIC_NDVI: {
    id: 'AGRIC_NDVI',
    descricao: 'Módulo Agricultura - NDVI',
  },

  AGRIC_RELATORIO_ESTOQUE_PRODUCAO_POR_PERIODO: {
    id: 'AGRIC_RELATORIO_ESTOQUE_PRODUCAO_POR_PERIODO',
    descricao: 'Módulo Agricultura - Relatório Estoque Produção',
  },
  AGRIC_ESTOQUE_IMPLANTAR_ESTOQUE_PROD: {
    id: 'AGRIC_ESTOQUE_IMPLANTAR_ESTOQUE_PROD',
    descricao: 'Módulo Agricultura - Implantar Estoque - Produção',
  },
  AGRIC_ESTOQUE_BAIXA_MANUAL_ESTOQUE_PROD: {
    id: 'AGRIC_ESTOQUE_BAIXA_MANUAL_ESTOQUE_PROD',
    descricao: 'Módulo Agricultura - Baixa Manual de Estoque - Produção',
  },
  AGRIC_ESTOQUE_TRANSF_ESTOQUE_PROD: {
    id: 'AGRIC_ESTOQUE_TRANSF_ESTOQUE_PROD',
    descricao: 'Módulo Agricultura - Transferência Estoque - Produção',
  },

  PEC_CAMPO: {
    id: 'PEC_CAMPO',
    descricao: 'Módulo Pecuária - Cadastro de Campo',
  },
  PEC_ANO_PECUARIO: {
    id: 'PEC_ANO_PECUARIO',
    descricao: 'Módulo Pecuária - Cadastro de Ano Pecuário',
  },
  PEC_PROCEDIMENTO: {
    id: 'PEC_PROCEDIMENTO',
    descricao: 'Módulo Pecuária - Cadastro de Procedimento Pecuário',
  },
  PEC_ANIMAL_CATEGORIA: {
    id: 'PEC_ANIMAL_CATEGORIA',
    descricao: 'Módulo Pecuária - Cadastro de Categoria Animal',
  },
  PEC_ANIMAL_ESPECIE: {
    id: 'PEC_ANIMAL_ESPECIE',
    descricao: 'Módulo Pecuária - Cadastro de Espécie Animal',
  },
  PEC_ANIMAL_LOTE: {
    id: 'PEC_ANIMAL_LOTE',
    descricao: 'Módulo Pecuária - Cadastro de Lote Animal',
  },
  PEC_ANIMAL_PELAGEM: {
    id: 'PEC_ANIMAL_PELAGEM',
    descricao: 'Módulo Pecuária - Cadastro de Pelagem Animal',
  },
  PEC_ANIMAL_RACA: {
    id: 'PEC_ANIMAL_RACA',
    descricao: 'Módulo Pecuária - Cadastro de Raça Animal',
  },
  PEC_IMPLANTAR_ESTOQUE: {
    id: 'PEC_IMPLANTAR_ESTOQUE',
    descricao: 'Módulo Pecuária - Implantar Estoque Animal',
  },
  PEC_COMPRA: {
    id: 'PEC_COMPRA',
    descricao: 'Módulo Pecuária - Compra de Animais',
  },
  PEC_VENDA: {
    id: 'PEC_VENDA',
    descricao: 'Módulo Pecuária - Venda de Animais',
  },
  PEC_NASCIMENTO: {
    id: 'PEC_NASCIMENTO',
    descricao: 'Módulo Pecuária - Nascimento de Animais',
  },
  PEC_OUTRAS_SAIDAS: {
    id: 'PEC_OUTRAS_SAIDAS',
    descricao: 'Módulo Pecuária - Outras Saídas',
  },
  PEC_TRANSF_CAMPO: {
    id: 'PEC_TRANSF_CAMPO',
    descricao: 'Módulo Pecuária - Transferência de Campo',
  },
  PEC_EVOLUCAO: {
    id: 'PEC_EVOLUCAO',
    descricao: 'Módulo Pecuária - Evolução Animal',
  },
  PEC_PLANEJAR_MANEJO: {
    id: 'PEC_PLANEJAR_MANEJO',
    descricao: 'Módulo Pecuária - Planejar Manejo',
  },
  PEC_EXECUTAR_MANEJO: {
    id: 'PEC_EXECUTAR_MANEJO',
    descricao: 'Módulo Pecuária - Executar Manejo',
  },
  PEC_PESAGEM: {
    id: 'PEC_PESAGEM',
    descricao: 'Módulo Pecuária - Pesagem',
  },
  PEC_REL_ANIMAIS_ATIVOS: {
    id: 'PEC_REL_ANIMAIS_ATIVOS',
    descricao: 'Módulo Pecuária - Relação de Animais Ativos',
  },
  PEC_REL_ANIMAIS_MOVIMENTACAO: {
    id: 'PEC_REL_ANIMAIS_MOVIMENTACAO',
    descricao: 'Módulo Pecuária - Relatório de Movimentação Animal',
  },

  ESTOQUE_LOCAL_ESTOQUE: {
    id: 'ESTOQUE_LOCAL_ESTOQUE',
    descricao: 'Módulo Estoque - Local de Estoque',
  },
  TRIBUTARIO_NATUREZA_OPERACAO: {
    id: 'TRIBUTARIO_NATUREZA_OPERACAO',
    descricao: 'Módulo Estoque - Natureza de Operação',
  },
  ESTOQUE_ENTRADA_ESTOQUE: {
    id: 'ESTOQUE_ENTRADA_ESTOQUE',
    descricao: 'Módulo Estoque - Entrada de Estoque',
  },
  ESTOQUE_IMPLANTAR_ESTOQUE: {
    id: 'ESTOQUE_IMPLANTAR_ESTOQUE',
    descricao: 'Módulo Estoque - Implantar Estoque',
  },
  ESTOQUE_BAIXAR_MANUAL_ESTOQUE: {
    id: 'ESTOQUE_BAIXAR_MANUAL_ESTOQUE',
    descricao: 'Módulo Estoque - Baixa Manual de Estoque',
  },
  ESTOQUE_TRANSF_ESTOQUE: {
    id: 'ESTOQUE_TRANSF_ESTOQUE',
    descricao: 'Módulo Estoque - Transferência Estoque',
  },
  ESTOQUE_RELATORIO_ESTOQUE_ATUAL: {
    id: 'ESTOQUE_RELATORIO_ESTOQUE_ATUAL',
    descricao: 'Módulo Estoque - Relatório Estoque Atual',
  },
  ESTOQUE_RELATORIO_ESTOQUE_POR_PERIODO: {
    id: 'ESTOQUE_RELATORIO_ESTOQUE_POR_PERIODO',
    descricao: 'Módulo Estoque - Relatório Estoque Por Período',
  },
  ESTOQUE_RELATORIO_REPOSICAO_ESTOQUE_MINIMO: {
    id: 'ESTOQUE_RELATORIO_REPOSICAO_ESTOQUE_MINIMO',
    descricao: 'Módulo Estoque - Relatório Reposição Estoque Mínimo',
  },

  FIN_CONTAS_PAGAR: {
    id: 'FIN_CONTAS_PAGAR',
    descricao: 'Módulo Financeiro - Contas à Pagar',
  },
  FIN_CONTAS_PAGAR_RECORRENTE: {
    id: 'FIN_CONTAS_PAGAR_RECORRENTE',
    descricao: 'Módulo Financeiro - Conta à Pagar Recorrente',
  },
  FIN_CONTAS_RECEBER: {
    id: 'FIN_CONTAS_RECEBER',
    descricao: 'Módulo Financeiro - Contas à Receber',
  },
  FIN_CONTROLE_CAIXA: {
    id: 'FIN_CONTROLE_CAIXA',
    descricao: 'Módulo Financeiro - Controle de Caixa',
  },
  FIN_CONTROLE_BANCO: {
    id: 'FIN_CONTROLE_BANCO',
    descricao: 'Módulo Financeiro - Controle de Banco',
  },
  FIN_FLUXO_CAIXA: {
    id: 'FIN_FLUXO_CAIXA',
    descricao: 'Módulo Financeiro - Fluxo de Caixa',
  },
  FIN_CAIXA: {
    id: 'FIN_CAIXA',
    descricao: 'Módulo Financeiro - Cadastro de Conta Caixa',
  },
  FIN_BANCO: {
    id: 'FIN_BANCO',
    descricao: 'Módulo Financeiro - Cadastro de Conta Banco',
  },
  FIN_PLANO_CONTA: {
    id: 'FIN_PLANO_CONTA',
    descricao: 'Módulo Financeiro - Plano de Contas Gerencial',
  },
  FIN_TRANS_BANCO_CAIXA: {
    id: 'FIN_TRANS_BANCO_CAIXA',
    descricao: 'Módulo Financeiro - Transferência Banco/Caixa',
  },
  FIN_CENTRO_CUSTO: {
    id: 'FIN_CENTRO_CUSTO',
    descricao: 'Módulo Financeiro - Centro de Custo',
  },
  FIN_CONCILIACAO_BANCARIA: {
    id: 'FIN_CONCILIACAO_BANCARIA',
    descricao: 'Módulo Conciliação Bancária - OFX',
  },

  FISCAL_EMITENTE: {
    id: 'FISCAL_EMITENTE',
    descricao: 'Módulo Fiscal - Cadastro Emitente',
  },
  FISCAL_CERTIFICADO_DIGITAL: {
    id: 'FISCAL_CERTIFICADO_DIGITAL',
    descricao: 'Módulo Fiscal - Certificado Digital',
  },
  FISCAL_NFE_EMISSAO: {
    id: 'FISCAL_NFE_EMISSAO',
    descricao: 'Módulo Fiscal - NFe Emissão',
  },
  FISCAL_MENSAGEM_FISCAL: {
    id: 'FISCAL_MENSAGEM_FISCAL',
    descricao: 'Módulo Fiscal - Mensagem Fiscal',
  },
  FISCAL_TABELA_TRIBUTARIA: {
    id: 'FISCAL_TABELA_TRIBUTARIA',
    descricao: 'Módulo Fiscal - Tabela Tributária',
  },
  FISCAL_FUNRURAL: {
    id: 'FISCAL_FUNRURAL',
    descricao: 'Módulo Fiscal - FUNRURAL',
  },
  FISCAL_MONITORAMENTO_NFE_COMPRA: {
    id: 'FISCAL_MONITORAMENTO_NFE_COMPRA',
    descricao: 'Módulo Fiscal - Monitoramento NFe de Compra',
  },

  PATRIMONIO_MANUTENCAO: {
    id: 'PATRIMONIO_MANUTENCAO',
    descricao: 'Módulo Patrimônio - Manutenção',
  },
  PATRIMONIO_MANUTENCAO_ALERTAS: {
    id: 'PATRIMONIO_MANUTENCAO_ALERTAS',
    descricao: 'Módulo Patrimônio - Manutenção Alertas',
  },
  PATRIMONIO_ABASTECIMENTO: {
    id: 'PATRIMONIO_ABASTECIMENTO',
    descricao: 'Módulo Patrimônio - Abastecimento',
  },
  PATRIMONIO_DEPRECIACAO: {
    id: 'PATRIMONIO_DEPRECIACAO',
    descricao: 'Módulo Patrimônio - Depreciação',
  },

  PAINEL_AGRARE_VISAO_AGRIC: {
    id: 'PAINEL_AGRARE_VISAO_AGRIC',
    descricao: 'Módulo Painel Agrare - Visão Agricultura',
  },
  PAINEL_AGRARE_VISAO_PEC: {
    id: 'PAINEL_AGRARE_VISAO_PEC',
    descricao: 'Módulo Painel Agrare - Visão Pecuária',
  },
  PAINEL_AGRARE_VISAO_FIN: {
    id: 'PAINEL_AGRARE_VISAO_FIN',
    descricao: 'Módulo Painel Agrare - Visão Financeira',
  },
  PAINEL_AGRARE_VISAO_PAT: {
    id: 'PAINEL_AGRARE_VISAO_PAT',
    descricao: 'Módulo Painel Agrare - Visão Patrimônio',
  },
  PAINEL_AGRARE_VISAO_PLUVIOMETRO: {
    id: 'PAINEL_AGRARE_VISAO_PLUVIOMETRO',
    descricao: 'Módulo Painel Agrare - Visão Pluviômetro',
  },

  // Todo - Verificar um nome melhor
  DASHBOARD: { id: 'DASHBOARD', descricao: 'Módulo Dashboard' },
  MAPA: { id: 'MAPA', descricao: 'Módulo Mapa' },
  CALENDARIO: { id: 'CALENDARIO', descricao: 'Módulo Calendário' },
  NOTIFICATION: { id: 'NOTIFICATION', descricao: 'Módulo as Notificações' },
  WHERE_TO_START: { id: 'WHERE_TO_START', descricao: 'Módulo o Comece aqui' },
  HELP_CENTER: { id: 'HELP_CENTER', descricao: 'Módulo a Central de Ajuda' },
  HELP_DRAWER: { id: 'HELP_DRAWER', descricao: 'Módulo o Drawer de Ajuda' },
};
